module.exports = __webpack_public_path__ + "static/Unlock_Your_Team-8969d0d3c6e9d51e14b55a42b2e6be61.png";